"use client";

import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import CarouselDots from "./carousel-dots";
import CarouselArrows from "./carousel-arrows";

import { RootStyle } from "./styles";

const Carousel = ({
  dotColor,
  children,
  arrowStyles,
  dots = false,
  arrows = true,
  slidesToShow = 4,
  spaceBetween = 10,
  dotStyles = {
    mt: 4,
  },
  ...props
}) => {
  const theme = useTheme();
  const [SlickCarousel, setSlickCarousel] = useState(null);

  useEffect(() => {
    let cancelled = false;
    void Promise.all([
      import("react-slick"),
      import("slick-carousel/slick/slick.css"),
      import("slick-carousel/slick/slick-theme.css"),
    ]).then(([m]) => {
      if (!cancelled) setSlickCarousel(() => m.default);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const settings = {
    dots,
    arrows,
    slidesToShow,
    rtl: theme.direction === "rtl",
    ...CarouselArrows(arrowStyles),
    ...CarouselDots({
      dotColor,
      sx: dotStyles,
    }),
    ...props,
  };

  return (
    <RootStyle space={spaceBetween}>
      {SlickCarousel ? (
        <SlickCarousel {...settings}>{children}</SlickCarousel>
      ) : (
        <div style={{ minHeight: 120 }} aria-hidden />
      )}
    </RootStyle>
  );
};

export default Carousel;
